import { OpcionSelect } from "src/components/input/TextInput"


// Departamentos
export type DepartamentoResp = {
  departamentoId: number
  nombre: string
}


export type MunicipioResp = {
  municipioId: number
  nombre: string
}

export type PerfilResp = {
  perfilId: string
  nombre: string
}

export type HorariosResp = {
  horarioDisponibilidadId: string
  descripcion: string
}

export type SedeResp = {
  sedeId: string
  nombre: string
}


export const departamentosRespToOpcionSelect = (departamentos: DepartamentoResp[]): OpcionSelect[] => {
  return departamentos.map((departamento) => ({
    valor: `${departamento.departamentoId}`,
    label: departamento.nombre,
  }));
}


export const municipiosRespToOpcionSelect = (municipios: MunicipioResp[]): OpcionSelect[] => {
  return municipios.map((municipio) => ({
    valor: `${municipio.municipioId}`,
    label: municipio.nombre,
  }));
}

export const perfilesRespToOpcionSelect = (perfiles: PerfilResp[]): OpcionSelect[] => {
  return perfiles.map((perfil) => ({
    valor: perfil.perfilId,
    label: perfil.nombre,
  }));
}

export const horariosRespToOpcionSelect = (horarios: HorariosResp[]): OpcionSelect[] => {
  return horarios.map((horario) => ({
    valor: horario.horarioDisponibilidadId,
    label: horario.descripcion,
  }));
}


export const sedeRespToOpcionSelect = (sedes: SedeResp[]): OpcionSelect[] => {
  return sedes.map((sede) => ({
    valor: sede.sedeId,
    label: sede.nombre,
  }));
}

// Adjuntos
// Obtener archivo
export type IobtenerArchivoRequest = {
  adjuntoId: string
}

// Guardar archivo
export type IguardarArchivoRequest = {
  file: File
  aspiranteId: string
}

export type IguardarArchivoResponse = {
  adjuntoId: string
}

// JUPITER
// Paises
export type PaisResponse = {
  paisId: string
  nombre: string
  abreviatura2: string
  abreviatura3: string
  codigoPais: number
}

export const paisesResponseToOpcionSelect = (paises: PaisResponse[]): OpcionSelect[] => {
  const opcionesDePaises =[
      ...paises.filter(pais => pais.codigoPais === 170),
      ...paises.filter(pais => pais.codigoPais !== 170),
    ];
  return opcionesDePaises.map((pais) => ({
    valor: pais.paisId,
    label: pais.nombre,
  }));
}

// Departamentos
export type DepartamentoResponse = {
  departamentoId: string
  nombre: string
  codigo: string
}


export const departamentosResponseToOpcionSelect = (departamentos: DepartamentoResponse[]): OpcionSelect[] => {
  return departamentos.map((departamento) => ({
    valor: departamento.departamentoId,
    label: departamento.nombre,
  }));
}


// Municipios 
export type MunicipioResponse = {
  municipioId: string
  nombre: string
  codigo: string
}


export const municipiosResponseToOpcionSelect = (municipios: MunicipioResponse[]): OpcionSelect[] => {
  return municipios.map((municipio) => ({
    valor: municipio.municipioId,
    label: municipio.nombre,
  }));
}



// MAESTROS

// Obtener maestro por tipo y unidad
export enum TipoMaestro {
  TIPOS_CONTRIBUYENTE = 'CONTRIBUYENTE',
  TIPOS_PROYECTO = 'PROYECTO',
  TIPOS_SOPORTE = 'SOPORTE',
}

export type MaestroPorTipoYUnidadRequest = {
  tipoMaestra: TipoMaestro;
  unidadId?: string;
};

export type MaestrosResponse = {
  tipoId: string
  nombre: string
  tipo: TipoMaestro
  unidadId: string
  unidadNombre: string
  descripcion: string
  descripcionInactivacion: string
  esActivo: boolean
  esGlobal: boolean
}

export const maestrosResponseToOpcionSelect = (maestros: MaestrosResponse[]): OpcionSelect[] => {
  return maestros.map((tipoContribuyente) => ({
    valor: tipoContribuyente.tipoId,
    label: tipoContribuyente.nombre,
  }));
}

// Guardar maesta
export type GuardarMaestroRequest = {
  nombre: string
  descripcion: string
  unidadId?: string
  tipo: TipoMaestro
}

// Editar maestra
export type EditarMaestroRequest = {
  tipoMaestraId: string
  nombre: string
  descripcion: string
  unidadId?: string
  tipo: TipoMaestro
}


// Inactivar maestra
export type InactivarMaestroRequest = {
  tipoMaestraId: string
  razon: string
}
